import React from 'react';
import QRScanner from '../../empresa/QRScanner/QRScanner';

// Escáner del staff: el mismo componente que usa la empresa, en modo staff
// (token `staff-token`, permisos de GET /api/auth/staff/me, sin "Rechazar").
const StaffScanner = () => <QRScanner mode="staff" />;

export default StaffScanner;
